import React, { useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import CommonDialogDataGrid from "../components/CommonDialogDataGrid";

const UpdateProcessMapDialog = ({
  open,
  onClose,
  onSave,
  allProcessList,
  mappedProcessKeys,
}) => {
  // Seed local state once from props
  const [selectedKeys, setSelectedKeys] = useState(
    () => mappedProcessKeys || []
  );

  // Derive diffs + hasChanges (no setState in effects)
  const { added, removed, hasChanges } = useMemo(() => {
    const addedLocal = selectedKeys.filter(
      (k) => !mappedProcessKeys.includes(k)
    );
    const removedLocal = mappedProcessKeys.filter(
      (k) => !selectedKeys.includes(k)
    );
    return {
      added: addedLocal,
      removed: removedLocal,
      hasChanges: addedLocal.length > 0 || removedLocal.length > 0,
    };
  }, [selectedKeys, mappedProcessKeys]);

  const handleSave = () => {
    onSave(added, removed);
  };

  // Initial sort for presentation
  const sortedInitialRows = useMemo(() => {
    return [...allProcessList]
      .sort((a, b) => {
        const aSel = mappedProcessKeys.includes(a.ruleConfigProcessKey);
        const bSel = mappedProcessKeys.includes(b.ruleConfigProcessKey);
        return aSel === bSel ? 0 : aSel ? -1 : 1;
      })
      .map((rp) => ({
        id: rp.ruleConfigProcessKey,
        ruleFlowGroupName: rp.ruleFlowGroupName,
        ruleSetCount: rp.ruleSetCount,
      }));
  }, [allProcessList, mappedProcessKeys]);

  const columns = [
    { field: "ruleFlowGroupName", headerName: "Ruleflow Group Name", flex: 2 },
    { field: "ruleSetCount", headerName: "# of Rule sets", flex: 1 },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      // Optional: remount to re-seed selection when mappedProcessKeys changes
      // key={mappedProcessKeys.join(",")}
    >
      <DialogTitle>Update Process Mapping</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            height: "calc(100vh - 300px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CommonDialogDataGrid
            // Or key just the grid:
            // key={mappedProcessKeys.join(",")}
            rows={sortedInitialRows}
            columns={columns}
            checkboxSelection
            selectionModel={selectedKeys}
            onSelectionChange={(newSelection) => setSelectedKeys(newSelection)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!hasChanges}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateProcessMapDialog;
